// @flow

import * as React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import 'reset-css';
import './index.css';

import App from './app';
import registerServiceWorker from './registerServiceWorker';
import { installUnauthorizedRedirect } from './auth/unauthorized';

installUnauthorizedRedirect(axios, window);

const root: any = document.getElementById('root');

if (root !== null) {
  ReactDOM.render(<App />, root);
}

registerServiceWorker();
